import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { performAction } from '@app/actions/customizeActions';

import Button from '@components/buttons/Button';
import './MoveTool.scss';
import useIntlMessage from '@app/hooks/use-intl-message';

const MoveTool = ({ performAction }) => {
  const [moveTopTitleAriaLabel, moveBottomTitleAriaLabel, moveLeftTitleAriaLabel, moveRightTitleAriaLabel] = useIntlMessage(
    'qau-art-move-top-aria-label',
    'qau-art-move-bottom-aria-label',
    'qau-art-move-left-aria-label',
    'qau-art-move-right-aria-label',
  );
  const moveArt = ({ target: { classList } }) => {
    const actionTypes = {
      down: 'translateDownSmall',
      right: 'translateRightSmall',
      left: 'translateLeftSmall',
      top: 'translateUpSmall',
    };

    const directionsList = ['left', 'right', 'top', 'down'];
    const direction = Array.from(classList).find(className => directionsList.includes(className));

    performAction(actionTypes[direction]);
  };

  return (
    <div id="qau-move-tool">
      <div className="move-tool-title">
        <LocalizedText id="qau-move-tool-text" />
      </div>
      <div className="move-tool-button-container">
        <Button className="move-btn top" onClick={moveArt} aria-label={moveTopTitleAriaLabel} />
        <Button className="move-btn left" onClick={moveArt} aria-label={moveLeftTitleAriaLabel} />
        <Button className="move-btn down" onClick={moveArt} aria-label={moveBottomTitleAriaLabel} />
        <Button className="move-btn right" onClick={moveArt} aria-label={moveRightTitleAriaLabel} />
      </div>
    </div>
  );
};

MoveTool.propTypes = {
  performAction: PropTypes.func.isRequired,
};

export default connect(null, { performAction })(MoveTool);
